export default __webpack_public_path__ + "static/media/AG18.28e5847d.mp3";